export const getDeviceGroups = (state) => {
  return state.deviceGroups.filter((g) => g.deviceGroupId !== 1);
};

export const getAllDeviceGroups = (state) => state.deviceGroups;
